import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { formatTimeToStr } from '@/utils/date';
import { getMyStated } from "@/api/workflowProcess";
export default {
  data: function data() {
    return {
      tableData: []
    };
  },
  methods: {
    view: function view(row) {
      this.$router.push({
        name: "workflowUse",
        query: {
          workflowMoveID: row.ID
        }
      });
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMyStated();
          case 2:
            res = _context.sent;
            if (res.code == 0) {
              _this.tableData = res.data.wfms;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  }
};